import {Routes} from "../types/constants";
import router from "../providers/router";
import { openAuthModal } from "./auth-modal.events";

export const NavigateToInternalUrl = (route: Routes | string = Routes.HOME) => {
    if (route === Routes.LOGIN) {
        openAuthModal('sign_in');
        return;
    }
    router.navigate(route).then();
}

export const NavigateToExternalUrl = (route: string) => {
    window.location.href = route;
}
